// extracted by mini-css-extract-plugin
module.exports = {"delta-pro-ultra-launch":"DPUDailyUse_delta-pro-ultra-launch__13kJ_"};